import { Skeleton, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { TabMainTitle } from "../../Components/View/Typography/title";
import GeneralTable from "../../Components/View/Table/TableGeneral";
import { ApiUrls } from "../../Components/Utils/globalVariables";
import useFetch from "../../Service/Hooks/useFetch";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function TaskResult({ data, loading, code }) {

    if(loading) {
        return (
            <Stack spacing={1}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography> {data?.anzsco} - {data?.persian_name} - {data?.name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {data?.tasks}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Stack>
        )
    } else {
        <Stack spacing={2}>
            <Skeleton sx={{width: "100%", height: "50px"}} variant="rounded" />
            <Skeleton sx={{width: "100%", height: "50px"}} variant="rounded" />
            <Skeleton sx={{width: "100%", height: "50px"}} variant="rounded" />
            <Skeleton sx={{width: "100%", height: "50px"}} variant="rounded" />
        </Stack>
    }
}
